import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';

import SimpleDataTable from './SimpleDataTable';

import { COLUMNS } from './config.jsx';

class BetSearchResults extends React.Component {
    static propTypes = {
        audits: ImmutablePropTypes.map,
    };

    static defaultProps = {
        audits: Map(),
    };

    constructor(props, context) {
        super(props, context);

        this.state = this.getState(props);
        this.results = {};
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState(this.getState(props));
    }

    getState(props) {
        const bets = [] , corrIds = [];

        props.audits.get('items').toJS().map((audit, idx) => {
            const items = [...audit.body.referredBetslip.bets];
            const executorId = audit.tags.filter( tag => String(tag).includes('executor')).map( tag => {
                const id = tag.split('-');
                return id[1];
            });
            items.map( (item, id) => {
                item.action = String(audit.type).charAt(0).toUpperCase() + String(audit.type).slice(1);
                item.id = idx + id;
                item.createdAt = audit.body.referredBetslip.createdAt;
                item.assignee = { ...audit.body.referredBetslip.assignee };
                item.executor = { id: executorId[0] };
                item.when = audit.when;

                if (!corrIds.includes(item.correlationID)) {
                    corrIds.push(item.correlationID);
                }

                bets.push(item);
            });
        });
        return { bets , corrIds };
    }

    getLegResults(bet) {
        const results = this.results[bet.id] || {};

        const legs = JSON.parse(JSON.stringify(bet.legs));

        const errors = {};

        Object.keys(results).forEach(index => {
            const result = results[index];
            const leg = legs[index];

            leg.result = {
                type: result.type
            };

            if (result.type === 'place') {
                leg.result.place = result.place;
            }

            if (result.price) {
                if (!leg.price || leg.price.f !== result.price) {
                    if (result.price.includes('/')) {
                        const fractionPrice = result.price.split('/');
                        leg.price = {
                            f: result.price,
                            d: odds.fraction.toDecimal(fractionPrice[0], fractionPrice[1])
                        };
                    } else if (!result.price.includes('/')) {
                        const fraction = odds.decimal.toFractional(result.price).simplify();
                        leg.price = {
                            f: fraction.n + '/' + fraction.d,
                            d: parseFloat(result.price, 10)
                        };
                    }
                }
            }

            if (result.priceType) {
                leg.priceType = result.priceType;
            }

            if (result.winReduction) {
                leg.result.winReduction = result.winReduction;
            }

            if (result.placeReduction) {
                leg.result.placeReduction = result.placeReduction;
            }

            if (result.r4Deductions) {
                leg.result.r4Deductions = parseFloat(result.r4Deductions);
            }

            if (bet.eachWay && result.eachWayReduction) {
                leg.eachWayReduction = result.eachWayReduction;
            }
        });

        for (const leg of legs) {
            if (!leg.result || !leg.result.type) {
                errors['Missing leg result'] = true;
            }

            if (leg.result && leg.result.type === 'place' && !leg.result.place) {
                errors['Missing place in leg result'] = true;
            }

            const ALLOWED_LEG_FIELDS = [ 'id', 'type', 'price', 'priceType', 'eachWayReduction', 'result' ];

            Object.keys(leg).forEach(key => {
                if (ALLOWED_LEG_FIELDS.indexOf(key) === -1) {
                    delete leg[key];
                }
            });

            if (leg.price) {
                delete leg.price.fractionalNumerator;
                delete leg.price.fractionalDenominator;
            }
        }

        return {
            legs,
            errors: Object.keys(errors)
        };
    }

    splitRow(bet) {
        if (bet.legs.length === 1) {
            return [bet];
        }

        return [ { ...bet , legs: [ bet.legs[0] ] } ];
    }

    getExpandedRow(bet) {
        return bet.legs.map((leg, index) => {
            const row = Object.assign({}, bet);

            if (index > 0) {
                delete row.correlationID;
                delete row.action;
            }

            row.legs = [leg];

            if (index) {
                delete row.placedAt;
                delete row.account;
                delete row.stakeFactor;
                delete row.eachWay;
                delete row.type;
                delete row.stakePerLine;
                delete row.totalStake;
                delete row.payout;
                delete row.maxBet;
                delete row.channel;
                delete row.eachWay;
            }

            return row;
        });
    }

    render() {
        const { bets, corrIds } = this.state;

        return (
            <div className='bet-search-results'>
                <SimpleDataTable
                    className='simple-data-table-container--fixed'
                    header={ true }
                    columns={ COLUMNS }
                    data={ bets }
                    corrIds={corrIds}
                    expanded={ this.getExpandedRow.bind(this)}
                    splitRow={ this.splitRow.bind(this)}
                    dataTest='bet-search-results'
                />
            </div>
        );
    }
}

export default BetSearchResults;
